import { redirectionPoints } from './../../constant';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Observable, Subscription } from 'rxjs/Rx';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { animateFactory } from 'ng2-animate';
import { environment } from '../../../';
import { User } from '../../model'
import { CookieNames, BasicRoutes, CircleUIOptions, AlertMessages, Status, ApiEndpoints, PaperTypes, TransactionType, AuthTypes, LoginTypes,PaymentStatus } from '../../constant';

/**
 * import services
 */
import { CookieManagerService, ErrorManagerService, OrderBy, HttpClientService, ShoppingCartService, CustomObserverService, BasicTimerService, LoginRedirectService, RegistrationFeeService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { PaperSet, OnlinePaper } from '../../model'
declare var $: any;
import swal from 'sweetalert2';
import { LocalStorageService } from 'angular-2-local-storage';


@Component({
  selector: 'app-paper-sets',
  templateUrl: '../views/paper-sets.component.html',
  styleUrls: ['../../../css/paper-sets.component.css']
  // animations: [animateFactory(400, 90, 'ease-in')]
})
export class PaperSetsComponent implements OnInit, OnDestroy {

  // @ViewChild(CircleProgressComponent) circleComp: CircleProgressComponent;
  // @ViewChild(SemiCircleProgressComponent) semiCircleComp: SemiCircleProgressComponent;

  private papersUrl: string = BasicRoutes.clientPapers;
  public paperSets: Array<PaperSet> = [];
  public paperSetsStatics: any = [];
  public paperSetSummary: string;
  public paperSetPrice: string;
  public paperSetSummaryPresentage: number = 0;

  public paperPaymentUrl: string = BasicRoutes.clientPayment;
  public summary: number;
  public pageNumber: number = 1;
  public noPaperSets: boolean = false;
  public isScoral: boolean = true;
  public onlinePaper: OnlinePaper = new OnlinePaper();
  public perfNowStart = performance.now();
  public hasEnoughBalence: boolean = true;
  public paymentId: string;
  public offerObject: Object = {};
  private param: string;
  public isShowingMessage: boolean = false;

  public typeIdForOnline: string = PaperTypes.online;
  public typeIdForPapers: string = PaperTypes.revision;
  public typeIdTermtest: string = PaperTypes.termTest;
  public typeIdForMyPapers: string = PaperTypes.myPapers;
  public idForMyPapers: string = ApiEndpoints.paperTypeMyPapers;

  public myPapersTypeIdForAll: string = ApiEndpoints.paperUserStatusAll;
  public myPapersTypeIdForNew: string = ApiEndpoints.paperUserStatusNew;
  public myPapersTypeIdInProgress: string = ApiEndpoints.paperUserStatusInProgress;
  public myPapersTypeIdForComplited: string = ApiEndpoints.paperUserStatusComplited;

  public paperSetType = ApiEndpoints.paperTypePapers;
  public paperType: string;
  public paperSetAllCount = 0;
  public userStatus: string;
  public username: boolean = false;
  public paperSetsCount: Array<any> = [];
  public user: any;
  public isMobile: boolean = false;
  public timer: any = 0;
  public payObjectForPaperSets: any;

  public apiRequstWaiter: boolean = true;

  public activePapersetTab: boolean = false;
  public isShowPopup: boolean = false;
  public imageProfile: any;

  constructor(
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private BasicTimerService: BasicTimerService,
    private ErrorManagerService: ErrorManagerService,
    private shoppingCartService: ShoppingCartService,
    public toastr: ToastsManager,
    private customObserverService: CustomObserverService,
    private trans: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private loginRedirectService: LoginRedirectService,
    private localStorageService: LocalStorageService,
    private registrationFeeService: RegistrationFeeService,

  ) {
    this.route
      .queryParams
      .subscribe((params: any) => {
        this.payObjectForPaperSets = params;
      });
  }

  getPaperSets(url) {
    this.apiRequstWaiter = false;
    this.paperSets = [];

    this.httpClientService.authGet(ApiEndpoints.replaceParms(url, { [ApiEndpoints.paperType]: this.paperSetType, [ApiEndpoints.pageNumber]: this.pageNumber, [ApiEndpoints.paperUserStatus]: this.userStatus }), null).subscribe(
      res => {
        //KinderJoy
        //setTimeout(() => {
          this.apiRequstWaiter = true;
          if ((res.papersets || false)) {
            this.paperSetAllCount = res.papersets.length === 0 ? this.paperSetAllCount : res.count;
            if (res.papersets.length === 0) {
              this.isScoral = false;
              this.isShowingMessage = true;
            }
            else {
              this.isScoral = true;
              this.isShowingMessage = false;
            }
            if (res.paperSetsCount) {
              this.paperSetsCount = res.paperSetsCount;
            }
            this.paperSets = [];
            res.papersets ? res.papersets.forEach(set => {
              this.paperSets.push(new PaperSet(set));
            }) : this.noPaperSets = false;
          } else {
            this.apiRequstWaiter = false
            this.isShowingMessage = true;
          }
        //}, 3000);

      }, e => {
        this.apiRequstWaiter = true;
        this.isShowingMessage = true;
        this.pageNumber = 1;
      });
  }
  /**
   * Get paper set statics
   * (new,start,compleate,toBuy)
   */
  // getPaperSetStatics() {
  //   this.httpClientService.authGet(ApiEndpoints.paperSetStaticts, null).subscribe(response => {
  //     this.paperSetsStatics = response.paperSetsInfo;
  //     this.summary = response.summary.average;
  //     this.paperSetSummary = response.summary.average !== 100 ? Math.round(response.summary.average).toFixed(1) + '%' : Math.round(response.summary.average) + '%';
  //     this.paperSetSummaryPresentage = response.summary.average / 100;
  //     // this.circleComp.animate(this.paperSetSummaryPresentage);
  //   }, error => {

  //   });

  // }

  showSuccess(message: string) {
    this.toastr.success(message, AlertMessages.success);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.apiRequstWaiter = false;
    // this.refreshAccount(); // Temporary
    this.cookieManagerService.setCookie(CookieNames.paperStartStatus, 'false', false, 1);
    this.getOfferImage();
    // get user
    this.getUser(callback => {


      this.route.params.subscribe(params => {
        this.param = params['filter'];
        this.pageNumber = 1;
        if (this.param) {

          this.changeActiveClass('paperType-button', this.param);

          if (this.param == PaperTypes.online) {
            this.paperSetType = ApiEndpoints.paperTypeOnline;
            this.getPaperSets(ApiEndpoints.getOnlinePaperSets); // change to the new end point and check all getPaperSets method and pass the correct URL 
          }
          else if (this.param == PaperTypes.termTest) {
            this.paperSetType = ApiEndpoints.paperTypeTermtest;
            this.getPaperSets(ApiEndpoints.getPaperSets);
          }
          else if (this.param == PaperTypes.myPapers) {
            this.paperSetType = ApiEndpoints.paperTypeMyPapers;
            this.userStatus = this.myPapersTypeIdForAll;
            this.paperSets = [];
            if (this.payObjectForPaperSets.code) {
              this.isPayment(this.payObjectForPaperSets.code);
            } else {
              this.toCheckLoginPopup();
              this.apiRequstWaiter = true;
              this.isShowingMessage = true;
              this.pageNumber = 1;
            }
          }
          else if (this.param == PaperTypes.revision) {
            this.paperSetType = ApiEndpoints.paperTypePapers;
            this.getPaperSets(ApiEndpoints.getPaperSets);
          }
          else {
            this.router.navigate(['home/exams']);
            this.paperSetType = ApiEndpoints.paperTypePapers;
            this.getPaperSets(ApiEndpoints.getPaperSets);
          }
        }
        else {
          $('#revision').addClass('active');
          this.paperSetType = ApiEndpoints.paperTypePapers;
          this.getPaperSets(ApiEndpoints.getPaperSets);
        }
        // if (this.param != PaperTypes.myPapers) {
        //   this.getPaperSets();
        // }
      });
      let mypapersIsActive = this.router.isActive(BasicRoutes.mypapers, false);
      if (mypapersIsActive) {
        this.activePapersetTab = true;
      }
      this.route.queryParams.filter(params => params.online).subscribe(params => {
        params.online == 'true' ? this.isShowPopup = true : this.isShowPopup = false;
        this.timer = setTimeout(() => {
          $("#msg-modal").hide();
        }, 15000);
      });
    });
  }


  // isPayment(id) {
  //   let that = this.trans;
  //   this.httpClientService.authGet(ApiEndpoints.checkPayment + id, null).subscribe(response => {
  //     if (response.success) {console.log(response);
  //       if (this.isMobile) {
  //         window.location.href = ApiEndpoints.MOBILE_APP_URL;
  //         window.close();
  //       } else {
  //         swal({
  //           title: that.instant('SUCCESS_BUY_PAPER'),
  //           text: that.instant('SUCCESS_BUY_PAPER_TEXT'),
  //           confirmButtonText: that.instant('SW_MESSAGE1'),
  //         })
  //       }
  //     } else {
  //       if (response.type) {
  //         swal({
  //           title: that.instant(TransactionType[response.type].title),
  //           text: that.instant(TransactionType[response.type].text)
  //         })
  //       }
  //     }
  //   }, error => {
  //     swal({
  //       title: that.instant('CANCEL_BUY_PAPER'),
  //       text: error.message
  //     })
  //   });
  // }

  ngAfterViewInit() {
    if (this.param) {
      this.changeActiveClass('paperType-button', this.param);

    }
    else {
      $('#revision').addClass('active');
    }
  }


  onScroll() {
    if (!this.isScoral) {
      return;
    }
    // return;
    this.pageNumber += 1;
    if (this.isScoral) {
      if (this.paperSetType === ApiEndpoints.paperTypeOnline) {
        this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getOnlinePaperSets, { [ApiEndpoints.paperType]: this.paperSetType, [ApiEndpoints.pageNumber]: this.pageNumber, [ApiEndpoints.paperUserStatus]: this.userStatus }), null).subscribe(response => {
          if (response.papersets.length === 0) {
            this.isScoral = false;
          }
        }, error => {

        });
      } else {
        this.getPaperSetsForScoral();
      }
    }
  }

  getPaperSetsForScoral() {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperSets, { [ApiEndpoints.paperType]: this.paperSetType, [ApiEndpoints.pageNumber]: this.pageNumber, [ApiEndpoints.paperUserStatus]: this.userStatus }), null).subscribe(response => {
      // this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperSets, { [ApiEndpoints.paperType]: this.paperSetType , [ApiEndpoints.pageNumber]: this.pageNumber }), null).subscribe(response => {
      if (response.papersets.length === 0) {
        this.isScoral = false;
      }
      if (response.paperSetsCount) {
        this.paperSetsCount = response.paperSetsCount;
      }
      let newPaperSets: Array<PaperSet> = [];
      newPaperSets = response.papersets;
      this.paperSetAllCount = response.papersets.length === 0 ? this.paperSetAllCount : response.count;
      if (newPaperSets.length !== 0) {
        response.papersets.forEach(element => {
          this.paperSets.push(new PaperSet(element));
          // if (element.startAt && element.isOnlinePaper) {
          //   this.newTimeCounter(element);
          // }
        });
      }
    }, error => {

    });
  }

  /**
   * Payment popup
   */
  // paperSetRouter(paperset) {
  //   this.cookieManagerService.setCookie(CookieNames.paperSet, paperset, true, 1);
  //   this.cookieManagerService.setCookie(CookieNames.paperSettitle, paperset.title, false, 1);
  //   // console.log(paperset.userInfo.accessLevel)
  //   if (paperset.userInfo.accessLevel == Status.lock) {
  //     if (this.onlinePaper && this.dateTimeDiff(new Date(paperset.blockAt)) <= 0) {
  //       this.onlinePaper.type = this.dateTimeDiff(new Date(paperset.endAt)) >= 0 ? "CANTBUY" : "NOTDONE"
  //       this.onlinePaper.canAccessPaper = false;
  //       this.onlineAlert(paperset, false);
  //       return;
  //     }

  //     //this.paidPaperSets(paperset);
  //     return;
  //   }

  //   if (this.onlinePaper) {
  //     if (this.onlinePaper.canAccessPaper) { // tslint:disable-line
  //       this.onlineAlert(paperset, true);
  //       this.cookieManagerService.setCookie(CookieNames.paperTitle, '', false, 1);
  //       this.cookieManagerService.setCookie(CookieNames.onlineExam, 'ONLINE', false, 1);
  //       this.cookieManagerService.setCookie(CookieNames.paperSetKey, paperset._id, false, 1);
  //       return;
  //     }
  //     this.onlineAlert(paperset, false);
  //     return;
  //   } else {
  //     this.router.navigate(['home/exams/' + paperset._id + '/papers']);
  //     this.cookieManagerService.setCookie(CookieNames.onlineExam, 'NOTONLINE', false, 1)
  //   }

  // }

  onlineAlert(paperset, canGo) {
    let that = this;
    let resultReleaseAt = new Date(paperset.userInfo.resultReleaseAt);
    let realDate = new Date(paperset.startAt);
    this.onlinePaper.startAt = realDate.toLocaleDateString().replace(new RegExp('/', 'g'), '-') + ',' + that.trans.instant('TIME') + (new Date(paperset.startAt)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    this.onlinePaper.resultReleaseAt = resultReleaseAt.toLocaleDateString().replace(new RegExp('/', 'g'), '-') + that.trans.instant('DAYS') + ',' + that.trans.instant('TIME') + resultReleaseAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    let notstart = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5><strong>${that.trans.instant('EXAM_START_DATE') + this.onlinePaper.startAt}</strong>`;
    let startpaper = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5>`;
    let start2ndpaper = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5><strong>${that.trans.instant('START_SECOND_PART')}</strong>`;
    let waitforresults = `විභාගය අවසන්, ඔබගේ ප්‍රතිඵල <strong>${this.onlinePaper.resultReleaseAt}</strong> නිකුත්වනු ඇත.`;
    let notDone = that.trans.instant('ONLY_RELASE_FOR_PARTICIPATERS');
    let results = paperset.userInfo.isResultsReleased && paperset.userInfo.marks != undefined ? `<br><br>ඔබ ලබාගත් ලකුණු : <strong>${paperset.userInfo.marks}/ 200</strong> <br><br> ${that.trans.instant('GOTO_REPORTS')}` : that.trans.instant('NOT_COMPLETE_CORRECTLY');
    let cantbuy = that.trans.instant('CANNOT_BUY');
    const EXAM_STATE = {
      NOTSTART: notstart,
      START: startpaper,
      SECONDNDSTART: start2ndpaper,
      END: waitforresults,
      NOTDONE: notDone,
      RESULT: results,
      CANTBUY: cantbuy
    }

    if (!this.onlinePaper.type) {
      return
    }

    swal({
      title: paperset.title,
      html: EXAM_STATE[this.onlinePaper.type],
      showCancelButton: false,
      showConfirmButton: canGo,
      cancelButtonColor: '#f39c12',
      customClass: 'online-exam-alert',
      confirmButtonText: that.trans.instant('START_PAPER'),
    }).then(function () {
      that.router.navigate(['/home/exams/papers/' + paperset.userInfo.paperId + '/parts']);
    }, function (dismiss) {

    })
  }

  // paidPaperSets(paperset) {
  //   let that = this;
  //   that.refreshAccount();
  //   that.coinAvailability(paperset.price)
  //   swal({
  //     title: paperset.title,
  //     html: `<p>${that.trans.instant('CURRENCY_CODE') + Math.round(paperset.price).toFixed(2).toString()}</p><h5>${paperset.title + ' ' + that.trans.instant('ENTER_TO_GET_SET')}</h5>`,
  //     showLoaderOnConfirm: true,
  //     showCancelButton: that.hasEnoughBalence,
  //     confirmButtonText: that.trans.instant('BUY_PAPERSET'),
  //     cancelButtonText: 'Use Points',
  //     customClass: that.hasEnoughBalence ? 'point-payment' : '',
  //   }).then(function () {
  //     that.cookieManagerService.setCookie(CookieNames.paperSetPrice, Math.round(paperset.price).toFixed(2).toString(), false, 1);
  //     that.payment(paperset._id);
  //   }, function (dismiss) {
  //     if (dismiss === 'cancel') {
  //       swal({
  //         title: paperset.title,
  //         imageUrl: `${ApiEndpoints.APP_URL}/assets/img/points-yellow.svg`,
  //         imageWidth: 60,
  //         imageHeight: 60,
  //         html: `<p>${that.trans.instant('CURRENCY_CODE') + Math.round(paperset.price).toFixed(2).toString()}</p><h5>Grade5 Points භාවිතා කර ප්‍රශ්න පත්‍රය ලබාගැනීමට තහවුරු කරන්න</h5>`,
  //         showCancelButton: true,
  //         cancelButtonColor: '#f39c12',
  //         confirmButtonText: that.trans.instant('BTN_CONFIRM'),
  //         cancelButtonText: 'ඉවත්වන්න',
  //         customClass: 'point-paymen-in',
  //         showLoaderOnConfirm: true,
  //         preConfirm: function () {
  //           return new Promise(function (resolve, reject) {
  //             that.httpClientService.authPostWithSetId(ApiEndpoints.paymentReferenceCode, {
  //             }, paperset._id).subscribe(response => {
  //               that.paymentId = response.invoiceId;
  //               resolve();
  //             }, error => {
  //               reject('Try, Again!')
  //             });
  //           })
  //         },
  //       }).then(function () {
  //         that.coinConfirem(paperset._id);
  //       }, function (dismiss) {

  //       })
  //     }
  //   }).catch((u) => {
  //     // console.log(u);
  //   });
  // }

  payment(id) {
    this.router.navigate(['home/exams/' + id + '/payment']);
  }

  coinConfirem(setId) {
    this.httpClientService.authPost(ApiEndpoints.coinConfirem, { invoiceId: this.paymentId, setid: setId }).subscribe(response => {
      let that = this;
      if (response) {
        this.paperSets = [];
        this.pageNumber = 1;
        this.getPaperSets(ApiEndpoints.getPaperSets);
        this.customObserverService.setPoints(response.points);
        this.cookieManagerService.setCookie(CookieNames.points, response.points, false, 1)
        if (response && response.code != 'invalied-amount') {
          swal({
            title: that.trans.instant('SUCCESS_BUY_PAPER'),
            text: that.trans.instant('SUCCESS_BUY_PAPER_TEXT'),
            confirmButtonText: that.trans.instant('SW_MESSAGE1'),
          });
        }
      }
    }, error => {
      // console.log(error)
    });
  }

  coinAvailability(price) {
    if (this.cookieManagerService.getCookie(CookieNames.points, false) >= price) {
      this.hasEnoughBalence = true;
    } else {
      this.hasEnoughBalence = false;
    }
  }

  refreshAccount() {
    this.httpClientService.authGet(ApiEndpoints.coinAvailability, false).subscribe(
      res => {
        if (res.points)
          this.customObserverService.setPoints(res.points);
        this.cookieManagerService.setCookie(CookieNames.points, res.points, false, 1)
      }, error => {
        // console.log(error);
      })
  }

  ngOnDestroy() {
    if (this.onlinePaper.timeInterval) {
      clearInterval(this.onlinePaper.timeInterval);
    }
  }

  getOfferImage() {
    this.httpClientService.get(ApiEndpoints.offerImage).subscribe(response => {
      this.offerObject = response;
    }, error => {

    });
  }

  // newTimeCounter(paperset) {
  //   this.onlinePaper.currentTime = new Date(paperset.currentTime);
  //   this.onlinePaper.leftSeconds = this.dateTimeDiff(new Date(paperset.startAt));
  //   this.onlinePaper.timeInterval = setInterval(() => {
  //     this.onlinePaper.currentTime.setSeconds(this.onlinePaper.currentTime.getSeconds() + 1);
  //     this.timeDiff_performanceNow(this.onlinePaper.leftSeconds, this.perfNowStart, paperset);
  //   }, 1000)
  // }

  z(n) { return (n < 10 ? '0' : '') + n; }

  // timeDiff_performanceNow(target, clientStart, paperset) {
  //   let distance = target - performance.now() + clientStart
  //   let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //   let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //   let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //   let seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //   if (hours < 0 || minutes < 0 || seconds < 0) {

  //     if (paperset.userInfo.clientStatus != 'NEW' && !paperset.userInfo.isResultsReleased) {
  //       this.onlinePaper.title = "ප්‍රතිඵල බලාපොරොත්තුවන්න!";
  //       this.onlinePaper.type = "END"
  //       this.onlinePaper.canAccessPaper = false;
  //     }

  //     if (paperset.userInfo.clientStatus == 'NEW' && this.dateTimeDiff(new Date(paperset.blockAt)) >= 0) {
  //       this.onlinePaper.type = "START";
  //       this.onlinePaper.title = "ආරම්භ කරන්න";
  //       this.onlinePaper.canAccessPaper = true;
  //     }

  //     if (paperset.userInfo.clientStatus != 'NEW' && paperset.userInfo.isResultsReleased) {
  //       this.onlinePaper.type = "RESULT";
  //       this.onlinePaper.title = 'සාර්ථකව නිම කර නොමැත';
  //       this.onlinePaper.canAccessPaper = false;
  //     }

  //     if (paperset.userInfo.clientStatus == 'INPROGRESS' && this.dateTimeDiff(new Date(paperset.endAt)) >= 0) {
  //       this.onlinePaper.title = "ආරම්භ වී ඇත";
  //       this.onlinePaper.type = "SECONDNDSTART"
  //       this.onlinePaper.canAccessPaper = true;
  //     }

  //     if (paperset.userInfo.clientStatus == 'NEW' && this.dateTimeDiff(new Date(paperset.endAt)) <= 0) {
  //       this.onlinePaper.type = "NOTDONE";
  //       this.onlinePaper.title = "විභාගය අවසන්";
  //       this.onlinePaper.canAccessPaper = false
  //     } else if (paperset.userInfo.clientStatus == 'NEW' && this.dateTimeDiff(new Date(paperset.blockAt)) <= 0) {
  //       this.onlinePaper.type = "NOTDONE";
  //       this.onlinePaper.title = "ආරම්භ වී ඇත";
  //       this.onlinePaper.canAccessPaper = false;
  //     }

  //   }
  //   else {
  //     this.onlinePaper.canAccessPaper = false;
  //     this.onlinePaper.type = "NOTSTART";
  //     this.onlinePaper.days = this.z(days);
  //     this.onlinePaper.minite = this.z(hours) + ':' + this.z(minutes) + ':' + this.z(seconds);
  //   }
  // }

  dateTimeDiff(target: Date): number {
    return (target.getTime() - this.onlinePaper.currentTime.getTime());
  }

  /**
    * kaushalya
    * 2017-10-09
    * get the paper list according to paper type
    */
  getPaperSetbyType(event, type) {
    //remove and add new class
    this.changeActiveClass('paperType-button', type);
    // set the type
    this.paperSetType = type;
    // set page id as one
    this.pageNumber = 1;
    // can scoral
    this.isScoral = true;
    // set user status as 0
    this.userStatus = 'ALL';
    // get the paperset
    this.getPaperSets(ApiEndpoints.getPaperSets);
  }

  /**
   * kauhsalya
   *2017-0-11
   * get user papers according to the user status
   */
  getPaperSetByUserType(event, type) {

    // set the type
    this.paperSetType = this.idForMyPapers;
    // set page id as one
    this.pageNumber = 1;
    // can scoral
    this.isScoral = true;
    // set user status as 0
    this.userStatus = type;
    this.changeActiveClass('paperStatusType-button', type);
    // $('.paperStatusType-button').removeClass('active');
    // $('#' + type).addClass('active');


    this.getUser(callback => {
      // get the paperset
      if (this.username) {
        this.getPaperSets(ApiEndpoints.getPaperSets);
      } else {
        this.paperSets = [];
        // show the login pop up
        $('#log-in-pop').modal('show');
      }
    });
  }

  changeActiveClass(buttonClss, type) {
    $('.' + buttonClss).removeClass('active');
    $('#' + type).addClass('active');
  }

  /**
  * kauhsalya
  * 2017-0-11
  * get user papers according to the user status
  */
  getUser(callback) {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.username = true;
    }
    let imageProfile: any;

    if (this.user && this.user.image) {
      imageProfile = this.user.image;
    } else {
      imageProfile = '/assets/img/default-avatar.svg';
    }
    this.localStorageService.set(CookieNames.userImage, imageProfile);
    this.customObserverService.setData(imageProfile);
    if (this.user) {
      let userDetails = this.user;
      userDetails.image = '';
      if (this.user.firstname) {
        this.customObserverService.setName(this.user.firstname);
        callback(this.username);
      } else {
        this.customObserverService.setName(this.user.username);
        callback(this.username);
      }
    } else {
      callback(this.username);
    }

  }
  openCart() {
    this.shoppingCartService.resetTimer();
  }

  goToMyPapers() {
    this.getUser(callback => {
      if (this.username) {
        this.router.navigate([BasicRoutes.mypapers]).then((resolve) => {
          if (resolve) {
            this.activePapersetTab = true;
          }
        });
      }
      else {
        this.paperSets = [];
        // show the login pop up
        this.loginRedirectService.setRedirectPoint(redirectionPoints.mypapers);
        this.loginRedirectService.cickedMyPapers(true);
        $('#log-in-pop').modal('show');

      }
    });
  }

  deActivePapersetTab() {
    this.activePapersetTab = false;
  }

  getActivePapersetTab() {
    return this.activePapersetTab;
  }
  closePopup() {
    this.isShowPopup = false;
    $("#msg-modal").hide();
  }


  isPayment(id) {
    this.shoppingCartService.clearAll();
    let translateService = this.trans;
    this.httpClientService.authGet(ApiEndpoints.checkPayment + id, null).subscribe(response => {
      let transaction = (response.transaction || false);
      if ((response.transaction || false)) {
        if (this.isMobile) {
          window.location.href = ApiEndpoints.MOBILE_APP_URL + '/' + id;
          window.close();
        } else {
          if (transaction.currentAction == PaymentStatus.PENDING) {
            swal({
              title: translateService.instant('CANCEL_BUY_PAPER'),
              text: translateService.instant('TRY_AGAIN_ADDTOBILL'),
              confirmButtonText: translateService.instant('NOINT_TRY_AGAIN')
            })
          } else {
            swal({
              title: translateService.instant('SUCCESS_BUY_PAPER'),
              text: translateService.instant('SUCCESS_BUY_PAPER_TEXT'),
              confirmButtonText: translateService.instant('SW_MESSAGE1'),
            });
            // to set user object and authentication token
            this.paymentAfter(response.user, response.token, callback => {
              this.getPaperSets(ApiEndpoints.getPaperSets);
            });
          }

        }
        // clear the shoping details
        this.shoppingCartService.clearAll();
        this.cookieManagerService.removeCookie(CookieNames.isRemoveCartItem, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationFee, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationToken, '/');
        this.cookieManagerService.removeCookie(CookieNames.registrationCode, '/');
      } else {
        if ((transaction.type || false)) {
          swal({
            title: translateService.instant(TransactionType[transaction.type].title),
            text: translateService.instant(TransactionType[transaction.type].text)
          })
        }
        this.apiRequstWaiter = true;
        this.isShowingMessage = true;
        this.pageNumber = 1;
      }
    }, error => {
      this.apiRequstWaiter = true;
      this.isShowingMessage = true;
      this.pageNumber = 1;
      swal({
        title: translateService.instant('CANCEL_BUY_PAPER'),
        text: error.message
      });
    });
  }

  /**
   * Save user login details on Cookies and Localstorage with given User object and tokens 
   * with returns from authenticate api
   * 
   * @param {User} user 
   * @memberof AppLoginComponent
   */
  paymentAfter(user: User, token, callback) {
    if (user && user.image) {
      this.imageProfile = user.image;
    } else {
      this.imageProfile = '/assets/img/default-avatar.svg';
    }
    //this.localStorageService.remove(CookieNames.userImage);
    this.localStorageService.set(CookieNames.userImage, this.imageProfile);
    let userDetails = user;
    userDetails.image = '';
    this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(userDetails));
    this.cookieManagerService.setCookie(CookieNames.loginKey, AuthTypes.tokenPrefix + token, false);
    this.cookieManagerService.setCookie(CookieNames.loginType, LoginTypes.web, false);
    this.localStorageService.set(CookieNames.loginType, LoginTypes.web);
    if (user.firstname) {
      this.customObserverService.setName(user.firstname);
    } else {
      this.customObserverService.setName(user.username);
    }
    //this.getpaymentDetils.emit(true);
    this.registrationFeeService.setSendUserExitDetials(true);
    this.customObserverService.setData(this.imageProfile);
    this.toCheckLoginPopup();
    callback(user.username);
  }

  toCheckLoginPopup() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    this.user = userObj ? JSON.parse(userObj.toString()) : false;
    if (!this.user) {
      // show the login pop up
      $('#log-in-pop').modal('show');
    } else {
      if (this.paperSets.length == 0) {
        this.getPaperSets(ApiEndpoints.getPaperSets);
      }
    }
  }

  doLiveExamPayment(){

    

  }

}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/paper-sets.component.ts